exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.plans{\n    border-left: 4px solid #eabd75;\n}\n.back{\n    z-index: 0;\n}\n.v-input__slot{\n    margin-bottom: 0px !important\n}\n", ""]);

// exports
